import { Component, Input } from '@angular/core';
import { IagPortalDetailsXmlSection } from 'src/app/model/section/iag-portal-details-xml-section';

@Component({
  selector: 'app-iag-portal-details-xml-section',
  templateUrl: './iag-portal-details-xml-section.component.html',
  styleUrls: ['./iag-portal-details-xml-section.component.scss']
})
export class IagPortalDetailsXmlSectionComponent {
  @Input() iagPortalDetailsXmlSection: IagPortalDetailsXmlSection[] = [];

  constructor() {}
}
